import { FormlyFieldConfig } from '@ngx-formly/core';

export const basicCommonForm: FormlyFieldConfig[] = [
  {
    wrappers: ['row'],
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        key: 'id',
        type: 'input',
        props: {
          translate: true,
          label: 'formGenerator.uiElement.id.label',
          disabled: true,
        },
      },
      {
        key: 'type',
        type: 'input',
        hide: true,
        resetOnHide: false,
        props: {
          translate: true,
          hidden: true,
          label: 'formGenerator.uiElement.id.label',
          disabled: true,
        },
      },
    ],
  },
  {
    wrappers: ['row'],
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        key: 'key',
        type: 'input',
        props: {
          translate: true,
          label: 'formGenerator.uiElement.key.label',
          /*required: true,*/
        },
      },
    ],
  },
  {
    wrappers: ['row'],
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        wrappers: ['row'],
        className: 'form-wrapper--row',
        fieldGroup: [
          {
            key: 'props.label',
            type: 'input',
            props: {
              translate: true,
              label: 'formGenerator.uiElement.labelProp.label',
            },
          },
        ],
      },
    ],
  },
];
